import React from 'react';
import { PencilRuler, Printer, QrCode } from 'lucide-react';

export const HowItWorks = () => (
    <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-primary)' }}>
        <div className="container">
            <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                    How It Works
                </h2>
                <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                    Deployed across your entire venue in less than 30 minutes.
                </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px', position: 'relative' }}>
                {/* Optional subtle background line connecting them. We hide it on mobile using typical CSS later. */}
                <div className="hidden md:block" style={{ position: 'absolute', top: '40px', left: '10%', right: '10%', height: '2px', background: 'var(--border-subtle)', zIndex: 0 }}></div>

                {[
                    { step: 1, icon: PencilRuler, title: 'Map your venue', desc: 'Create your tables, sections, and staff profiles inside the Admin Portal.' },
                    { step: 2, icon: Printer, title: 'Place QR codes', desc: 'Print automated QR codes and place them precisely on your physical tables.' },
                    { step: 3, icon: QrCode, title: 'Customers scan', desc: 'Guests immediately view the menu, request service, and checkout.' }
                ].map((s, idx) => {
                    const Icon = s.icon;
                    return (
                        <div key={idx} style={{ position: 'relative', zIndex: 1, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'var(--bg-secondary)', border: '2px solid var(--border-focus)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
                                <Icon size={32} color="var(--accent-primary)" />
                            </div>
                            <div style={{ color: 'var(--accent-primary)', fontSize: '0.875rem', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '12px' }}>
                                Step {s.step}
                            </div>
                            <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '16px' }}>{s.title}</h3>
                            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>{s.desc}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);
